import { render, staticRenderFns } from "./PosReading.vue?vue&type=template&id=0c3102d7&"
import script from "./PosReading.vue?vue&type=script&lang=js&"
export * from "./PosReading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports